import cx from 'clsx';
import * as React from 'react';

import { IOfferSchema, IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './CountryBuildingsBannersNew.css';
import { AdfoxContainer } from '../../containers/Adfox';
import { getRailwayAndHighwaysPuids } from '../../utils/adfox';
import { CardSectionNew } from '../CardSectionNew';

export interface ICountryBuildingsBannersNewProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
  bannerIds: string[];
  onLoad: () => void;
  onBannerClick: () => void;
  visible: boolean;
}

export const CountryBuildingsBannersNew: React.FC<React.PropsWithChildren<ICountryBuildingsBannersNewProps>> = ({
  offer,
  bannerIds,
  onLoad,
  onBannerClick,
  visible,
}) => {
  return (
    <div className={cx(!visible && styles['hidden'])}>
      <CardSectionNew title={visible ? 'Проекты домов от строительных компаний' : undefined}>
        <div className={cx(styles['banners-container'])}>
          {bannerIds.map((randomId, index) => {
            return (
              <div data-testid="CountryBuildingsBannersNew" key={randomId} className={styles['banner']}>
                <AdfoxContainer
                  isNew
                  type="country_buildings_banner"
                  randomId={randomId}
                  positionInfo={`country_buildings_banner-${index + 1}`}
                  additionalPuids={getRailwayAndHighwaysPuids(offer)}
                  onLoad={onLoad}
                  onClick={onBannerClick}
                  minHeight="278px"
                  width="200px"
                />
              </div>
            );
          })}
        </div>
      </CardSectionNew>
    </div>
  );
};
